import React, { useState } from "react";
import { Card, Timeline, Table } from "antd";
import {
  Calendar,
  Crown,
  MapPin,
  Star,
  Eye,
  Waves,
  Sunrise,
  ChevronDown,
  ChevronRight,
  Play,
  X,
  ChevronLeft,
} from "lucide-react";
import HeaderComponent from "./Home/HeaderComponent";
import Footer from "./Home/Footer";
import { useNavigate } from "react-router-dom";
import { Camera, Clock, ZoomIn } from "lucide-react";
import { Modal } from "antd";
import temple from "../../assets/mahalaxmin-temple.jpg";
import g1 from "../../assets/Gallery/1.jpg";
import g2 from "../../assets/Gallery/2.jpg";
import g3 from "../../assets/Gallery/3.jpg";
import g4 from "../../assets/Gallery/4.jpg";
import g5 from "../../assets/Gallery/5.jpg";
import g6 from "../../assets/Gallery/6.jpg";
import g7 from "../../assets/Gallery/7.jpg";
import g8 from "../../assets/Gallery/8.jpg";
import g9 from "../../assets/Gallery/9.jpg";
import g10 from "../../assets/Gallery/10.jpg";

const TempleHistory = () => {
  const [expandedSections, setExpandedSections] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  // const [imageModalVisible, setImageModalVisible] = useState(false);
  const [activeCategory, setActiveCategory] = useState("all");
  const navigate = useNavigate();

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleImageClick = (image) => {
    console.log("Clicked item type:", image.type);
    setSelectedImage(image);
    // setImageModalVisible(true);
  };

  const galleryImages = [
    {
      id: 1,
      src: g1,
      title: "Akshay Tritiya",
      description: "Akshay Tritiya",
      category: "dolotsav",
      // featured: true,
    },
    {
      id: 2,
      src: g2,
      title: "The silver chariot",
      description: "The silver chariot",
      category: "rathotsav",
    },
    {
      id: 3,
      src: g3,
      title: "The Chariot Decorated with flowers and lights",
      description: "The Chariot Decorated with flowers and lights",
      category: "rathotsav",
    },
    {
      id: 4,
      src: g4,
      title: "Sun rays falling on deity during Kirnotsav",
      description: "Sun rays falling on deity during Kirnotsav",
      category: "kiranotsav",
    },
    {
      id: 5,
      src: g5,
      title: "Kirnotsav-Temple illuminated in evening",
      description: "Temple illuminated in evening",
      category: "kiranotsav",
    },
    {
      id: 6,
      src: g6,
      title: "Kiranotsav",
      description: "Faithful devotees in prayer",
      category: "kiranotsav",
    },
    {
      id: 7,
      src: g7,
      title: "Navratra-Pratipada",
      description: "Navratra-Pratipada",
      category: "navratra",
    },

    {
      id: 8,
      src: g8,
      title: "Navratra-Panchami",
      description: "Navratra-Pratipada",
      category: "navratra",
    },
    {
      id: 9,
      src: g9,
      title: "Navratra-Ashtami",
      description: "Navratra-Ashtami",
      category: "navratra",
    },
    {
      id: 10,
      src: g10,
      title: "Navratra-Dasara",
      description: "Navratra-Dasara",
      category: "navratra",
    },
    {
      id: 11,
      title: "Navratra 2025 jewellery cleaning ",
      description: "Cleaning of jewellery",
      category: "videos",
      type: "video",
      youtubeId: "N8jPPoavXfE",
      thumbnail: "https://img.youtube.com/vi/N8jPPoavXfE/maxresdefault.jpg",
    },
    {
      id: 12,
      title: "Navratra 2025 Mandir Cleaning",
      description: "Cleaning of Mandir for Navratra",
      category: "videos",
      type: "video",
      youtubeId: "LAQ_WE8JQuw",
      thumbnail: "https://img.youtube.com/vi/LAQ_WE8JQuw/maxresdefault.jpg",
    },
  ];

  const galleryCategories = [
    { id: "all", name: "All Events", icon: "📸" },
    { id: "dolotsav", name: "Dolotsav / Akshay Trutiya", icon: "🛕" },
    { id: "rathotsav", name: "Rathotsav", icon: "🙏" },
    { id: "kiranotsav", name: "Kiranotsav", icon: "🎉" },
    { id: "navratra", name: "Ashwin Navratra", icon: "🌅" },
    { id: "videos", name: "Videos", icon: "🎥" },
  ];

  const filteredImages =
    activeCategory === "all"
      ? galleryImages
      : galleryImages.filter((img) => img.category === activeCategory);

  // Daily routine data from the image
  const marathiRoutine = [
    { time: "पहाटे 4.45 वा.", activity: "मंदिर उघडण्याची वेळ", icon: "🚪" },
    { time: "पहाटे 5.00 वा.", activity: "पाद्यपूजा व मुखमार्जन", icon: "🦶" },
    { time: "पहाटे 5.30 ते 6.00 वा.", activity: "काकडा आरती", icon: "🙏" },
    { time: "सकाळी 9.30 ते 10.00", activity: "आरती", icon: "🔔" },
    {
      time: "दुपारी 12.30 ते 1.00",
      activity: "आरती व महानैवेद्य",
      icon: "🍽️",
      special: "(प्रत्येक शुक्रवारी सावं. 7.00 वा. महानैवेद्य)",
    },
    { time: "दुपारी 2.00 वा.", activity: "अलंकारिक पूजा", icon: "💐" },
    { time: "रात्री 8.15 वा.", activity: "आरती", icon: "🕯️" },
    { time: "रात्री 10.10 वा.", activity: "शेजआरती", icon: "🛏️" },
    {
      time: "रात्री 10.30 वा.",
      activity: "मंदिर बंद होण्याची वेळ",
      icon: "🚪",
    },
  ];

  const englishRoutine = [
    { time: "4.45 a.m.", activity: "Mandir Opening Time", icon: "🚪" },
    { time: "5.00 am", activity: "Padya Puja & Mukhmarjan", icon: "🦶" },
    { time: "5.30 am to 6.00 am", activity: "Kakad Aarti", icon: "🙏" },
    { time: "9.30 am to 10.00 am", activity: "Aarti", icon: "🙏" },
    {
      time: "12.30 pm to 1.00 pm",
      activity: "Aarti & Mahanivedya",
      icon: "🔔🍽️",
      special: "(Mahanivedya Every Friday 7.00 pm)",
    },
    { time: "2.00 pm", activity: "Alankarik Puja", icon: "💐" },
    { time: "8.15 pm", activity: "Aarti", icon: "🕯️" },
    { time: "10.10 pm", activity: "Shejaarti", icon: "🛏️" },
    { time: "10.30 pm", activity: "Mandir Closing Timing", icon: "🚪" },
  ];

  const shaktipeethsData = [
    {
      key: "1",
      no: "1",
      shaktipeeth: "Mahalaxmi Ambabai, Kolhapur",
      district: "Kolhapur",
      status: "Full",
      statusColor: "text-orange-600 bg-orange-100 font-bold",
    },
    {
      key: "2",
      no: "2",
      shaktipeeth: "Tulja Bhavani, Tuljapur",
      district: "Osmanabad",
      status: "Full",
      statusColor: "text-green-600 bg-green-100",
    },
    {
      key: "3",
      no: "3",
      shaktipeeth: "Renuka Devi, Mahur",
      district: "Nanded",
      status: "Full",
      statusColor: "text-green-600 bg-green-100",
    },
    {
      key: "4",
      no: "4",
      shaktipeeth: "Saptashrungi, Vani",
      district: "Nashik",
      status: "Half",
      statusColor: "text-blue-600 bg-blue-100",
    },
  ];

  const columns = [
    {
      title: "No.",
      dataIndex: "no",
      key: "no",
      width: 60,
      className: "font-semibold",
    },
    {
      title: "Shaktipeeth",
      dataIndex: "shaktipeeth",
      key: "shaktipeeth",
      className: "font-medium",
    },
    {
      title: "District",
      dataIndex: "district",
      key: "district",
    },
    {
      //title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <span
          className={`px-3 py-1 rounded-full text-sm font-medium ${record.statusColor}`}
        >
          {status}
        </span>
      ),
    },
  ];

  const rivers = [
    { name: "Kasari", color: "bg-blue-400" },
    { name: "Kumbhi", color: "bg-teal-400" },
    { name: "Tulsi", color: "bg-green-400" },
    { name: "Bhogawati", color: "bg-purple-400" },
    { name: "Saraswati", color: "bg-pink-400" },
  ];

  const timelineItems = [
    {
      color: "orange",
      children: (
        <div className="timeline-item">
          <h4 className="font-bold text-lg text-gray-800">
            7th Century CE (circa 634 CE)
          </h4>
          <p className="text-gray-600">
            Temple constructed during the Chalukya dynasty by King Karnadeva
          </p>
        </div>
      ),
    },
    {
      color: "blue",
      children: (
        <div className="timeline-item">
          <h4 className="font-bold text-lg text-gray-800">
            Architectural Heritage
          </h4>
          <p className="text-gray-600">
            Classic Chalukya and Hemadpanthi architectural styles implemented
          </p>
        </div>
      ),
    },
    {
      color: "green",
      children: (
        <div className="timeline-item">
          <h4 className="font-bold text-lg text-gray-800">
            Spiritual Recognition
          </h4>
          <p className="text-gray-600">
            Established as one of the three and a half Shaktipeeths in
            Maharashtra
          </p>
        </div>
      ),
    },
    {
      color: "purple",
      children: (
        <div className="timeline-item">
          <h4 className="font-bold text-lg text-gray-800">Present Day</h4>
          <p className="text-gray-600">
            Continues to attract millions of devotees annually
          </p>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-red-50">
        <HeaderComponent />
        <section className="py-16 px-4 relative overflow-hidden min-h-[500px]">
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${temple})`, // Replace with your temple image path
            }}
          ></div>

          {/* Overlay for better text readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-orange-500/80 to-red-500/80"></div>
          <div className="absolute inset-0 bg-black/40"></div>

          <div className="container mx-auto max-w-6xl text-center relative z-10 text-white">
            {/* <button
              onClick={() => navigate("/")}
              className="absolute left-0 top-0 flex items-center text-white hover:text-orange-100 transition-all mb-6 bg-black/30 px-4 py-2 rounded-lg backdrop-blur-sm"
            >
              <ArrowLeft className="h-5 w-5 mr-2" />
              Back to Home
            </button> */}

            {/* <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-8 backdrop-blur-sm border border-white/30">
              <img
                src= {logo}// Replace with temple icon/logo
                alt="Temple Icon"
                className="w-12 h-12 object-contain filter brightness-0 invert"
              />
            </div> */}

            <h1 className="text-4xl md:text-6xl font-bold mb-6 drop-shadow-lg">
              Temple Information
            </h1>
            <h2 className="text-xl md:text-2xl font-medium mb-4 drop-shadow-md">
              Shri Mahalaxmi Amababai Temple, Kolhapur
            </h2>
            <p className="text-lg md:text-xl max-w-4xl mx-auto leading-relaxed opacity-95 drop-shadow-md">
              Discover the ancient heritage and spiritual significance of one of
              Maharashtra's most revered Shaktipeeths
            </p>
          </div>
        </section>
        {/* Main Content */}
        <section className="py-16 px-4">
          <div className="container mx-auto max-w-6xl space-y-12">
            {/* Temple History */}
            <Card className="rounded-2xl shadow-xl border-orange-200">
              <div className="flex items-center mb-6">
                <Calendar className="h-8 w-8 text-orange-500 mr-4" />
                <h2 className="text-3xl font-bold text-gray-800">
                  Temple History
                </h2>
              </div>

              <div className="grid lg:grid-cols-2 gap-8">
                <div>
                  <Timeline items={timelineItems} />
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-red-50 border border-orange-200 rounded-xl p-6">
                  <div className="flex items-center mb-4">
                    <Crown className="h-6 w-6 text-orange-500 mr-3" />
                    <h3 className="text-xl font-semibold text-gray-800">
                      Key Historical Facts
                    </h3>
                  </div>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <span className="w-2 h-2 bg-orange-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span className="text-gray-700">
                        Constructed around{" "}
                        <strong>7th century CE (circa 634 CE)</strong>
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="w-2 h-2 bg-orange-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span className="text-gray-700">
                        Built during the <strong>Chalukya dynasty</strong> by
                        King Karnadeva
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="w-2 h-2 bg-orange-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span className="text-gray-700">
                        Features <strong>Chalukya and Hemadpanthi</strong>{" "}
                        architectural styles
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </Card>

            <Card className="rounded-2xl shadow-2xl border-orange-200 overflow-hidden">
              {/* Gallery Header */}
              <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white p-4 sm:p-8 text-center">
                <Camera className="h-8 w-8 sm:h-12 sm:w-12 mx-auto mb-4" />
                <h2 className="text-2xl sm:text-4xl font-bold mb-2">Events</h2>
                <p className="text-lg sm:text-xl opacity-90">
                  Sacred Moments & Divine Architecture
                </p>
              </div>

              <div className="p-8">
                {/* Category Filter */}
                <div className="flex flex-wrap justify-center gap-3 mb-8">
                  {galleryCategories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setActiveCategory(category.id)}
                      className={`px-4 py-2 rounded-full font-medium transition-all duration-300 flex items-center space-x-2 ${
                        activeCategory === category.id
                          ? "bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg"
                          : "bg-gray-100 text-gray-700 hover:bg-orange-50 hover:text-orange-600"
                      }`}
                    >
                      <span className="sm:hidden">{category.icon}</span>
                      <span className="hidden sm:inline">{category.name}</span>
                    </button>
                  ))}
                </div>

                {/* Gallery Grid */}
                {/* Gallery Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                  {/* Featured Item (Image or Video) */}
                  {filteredImages.find((item) => item.featured) && (
                    <div className="col-span-full lg:col-span-2 row-span-2">
                      <div
                        className="relative h-64 lg:h-80 rounded-xl overflow-hidden group cursor-pointer"
                        onClick={() =>
                          handleImageClick(
                            filteredImages.find((item) => item.featured)
                          )
                        }
                      >
                        <img
                          src={
                            filteredImages.find((item) => item.featured)
                              .type === "video"
                              ? filteredImages.find((item) => item.featured)
                                  .thumbnail
                              : filteredImages.find((item) => item.featured).src
                          }
                          alt={
                            filteredImages.find((item) => item.featured).title
                          }
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          {filteredImages.find((item) => item.featured).type ===
                          "video" ? (
                            <Play className="h-12 w-12 text-white" />
                          ) : (
                            <ZoomIn className="h-8 w-8 text-white" />
                          )}
                        </div>
                        {/* Video Play Button (Always Visible for videos) */}
                        {filteredImages.find((item) => item.featured).type ===
                          "video" && (
                          <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-red-600 rounded-full p-4 shadow-lg">
                              <Play className="h-8 w-8 text-white fill-white" />
                            </div>
                          </div>
                        )}
                        <div className="absolute bottom-4 left-4 text-white">
                          <h3 className="text-xl font-bold">
                            {filteredImages.find((item) => item.featured).title}
                          </h3>
                          <p className="text-sm opacity-90">
                            {
                              filteredImages.find((item) => item.featured)
                                .description
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Regular Gallery Items */}
                  {filteredImages
                    .filter((item) => !item.featured)
                    .map((item) => (
                      <div key={item.id} className="group">
                        <div
                          className="relative h-48 rounded-xl overflow-hidden cursor-pointer"
                          onClick={() => handleImageClick(item)}
                        >
                          <img
                            src={
                              item.type === "video" ? item.thumbnail : item.src
                            }
                            alt={item.title}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            {item.type === "video" ? (
                              <Play className="h-8 w-8 text-white" />
                            ) : (
                              <ZoomIn className="h-6 w-6 text-white" />
                            )}
                          </div>
                          {/* Video Play Button (Always Visible for videos) */}
                          {item.type === "video" && (
                            <div className="absolute inset-0 flex items-center justify-center">
                              <div className="bg-red-600 rounded-full p-3 shadow-lg">
                                <Play className="h-6 w-6 text-white fill-white" />
                              </div>
                            </div>
                          )}
                          <div className="absolute bottom-2 left-2 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <h4 className="text-sm font-semibold">
                              {item.title}
                            </h4>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </Card>
            <Card className="rounded-2xl shadow-xl border-orange-200">
              <div className="flex items-center mb-6">
                <Clock className="h-8 w-8 text-orange-500 mr-4" />
                <h2 className="text-3xl font-bold text-gray-800">
                  Daily Temple Routine
                </h2>
              </div>

              <div className="grid lg:grid-cols-2 gap-8">
                {/* Marathi Schedule */}
                <div className="bg-gradient-to-br from-orange-50 to-red-50 border border-orange-200 rounded-xl p-6">
                  <h3 className="text-lg sm:text-xl font-semibold text-orange-800 mb-4 sm:mb-6">
                    <span className="text-2xl mr-3">🕉️</span>
                    श्री करवीर निवासिनी मंदिरातील दिनचर्या
                  </h3>
                  <div className="space-y-3">
                    {marathiRoutine.map((item, index) => (
                      <div
                        key={index}
                        className="flex items-start p-3 bg-white rounded-lg border border-orange-100 hover:shadow-md transition-shadow"
                      >
                        <span className="text-xl mr-3 flex-shrink-0">
                          <Star />
                        </span>
                        <div className="flex-1">
                          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
                            <span className="font-medium text-orange-700">
                              {item.activity}
                            </span>
                            <span className="text-sm text-orange-600 font-semibold mt-1 sm:mt-0">
                              {item.time}
                            </span>
                          </div>
                          {item.special && (
                            <p className="text-xs text-orange-600 mt-1 italic">
                              {item.special}
                            </p>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* English Schedule */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-6">
                  <h3 className="text-xl font-semibold text-blue-800 mb-6 flex items-center">
                    <span className="text-2xl mr-3">⏰</span>
                    Daily Routine of Shree Karvirniwasini Mandir
                  </h3>
                  <div className="space-y-3">
                    {englishRoutine.map((item, index) => (
                      <div
                        key={index}
                        className="flex items-start p-3 bg-white rounded-lg border border-blue-100 hover:shadow-md transition-shadow"
                      >
                        <span className="text-xl mr-3 flex-shrink-0">
                          <Star />
                        </span>
                        <div className="flex-1">
                          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
                            <span className="font-medium text-blue-700">
                              {item.activity}
                            </span>
                            <span className="text-sm text-blue-600 font-semibold mt-1 sm:mt-0">
                              {item.time}
                            </span>
                          </div>
                          {item.special && (
                            <p className="text-xs text-blue-600 mt-1 italic">
                              {item.special}
                            </p>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Card>

            {/* Three and Half Shaktipeeths */}
            <Card className="rounded-2xl shadow-xl border-orange-200">
              <div className="flex items-center mb-6">
                <Star className="h-8 w-8 text-orange-500 mr-4" />
                <h2 className="text-3xl font-bold text-gray-800">
                  Three and Half Shaktipeeths in Maharashtra
                </h2>
              </div>

              <div className="hidden md:block mb-6">
                <Table
                  dataSource={shaktipeethsData}
                  columns={columns}
                  pagination={false}
                  className="rounded-lg shadow-sm"
                  rowClassName={(record) =>
                    record.key === "1" ? "bg-orange-50" : ""
                  }
                />
              </div>

              <div className="md:hidden space-y-4 mb-6">
                {shaktipeethsData.map((item) => (
                  <div
                    key={item.key}
                    className={`p-4 rounded-lg border ${
                      item.key === "3"
                        ? "bg-orange-50 border-orange-200"
                        : "bg-white border-gray-200"
                    }`}
                  >
                    <div className="flex justify-between items-center">
                      <div>
                        <h3 className="font-semibold text-gray-800">
                          {item.shaktipeeth}
                        </h3>
                        <p className="text-gray-600">{item.district}</p>
                      </div>
                      <span
                        className={`px-3 py-1 rounded-full text-sm font-medium ${item.statusColor}`}
                      >
                        {item.status}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-blue-800 font-medium">
                  <MapPin className="h-4 w-4 inline mr-2" />
                  Kolhapur is also referred to as{" "}
                  <strong>Karveer Kshetra</strong> or{" "}
                  <strong>Dakshin Kashi</strong>
                </p>
              </div>
            </Card>

            {/* Significance Section */}
            <Card className="rounded-2xl shadow-xl border-orange-200">
              <div className="flex items-center mb-6">
                <Eye className="h-8 w-8 text-orange-500 mr-4" />
                <h2 className="text-3xl font-bold text-gray-800">
                  The Significance of Shri Karveer Kshetra (Kolhapur)
                </h2>
              </div>

              <div className="space-y-6">
                {/* Interactive Significance Points */}
                <div className="grid md:grid-cols-2 gap-6">
                  <div
                    className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-xl p-6 cursor-pointer hover:shadow-lg transition-all"
                    onClick={() => toggleSection("shaktipeeth")}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-semibold text-green-800">
                        Complete Shaktipeeth
                      </h3>
                      {expandedSections.shaktipeeth ? (
                        <ChevronDown className="h-5 w-5" />
                      ) : (
                        <ChevronRight className="h-5 w-5" />
                      )}
                    </div>
                    {expandedSections.shaktipeeth && (
                      <p className="text-green-700 text-sm">
                        Karveer Kshetra is one of the three and a half
                        Shaktipeeths and is considered a complete (full)
                        Shaktipeeth. It is the original seat of Shri Mahalaxmi
                        Devi (Ambabai), worshipped as the goddess of prosperity
                        and protection.
                      </p>
                    )}
                  </div>

                  <div
                    className="bg-gradient-to-br from-purple-50 to-violet-50 border border-purple-200 rounded-xl p-6 cursor-pointer hover:shadow-lg transition-all"
                    onClick={() => toggleSection("spiritual")}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-semibold text-purple-800">
                        Spiritual Supremacy
                      </h3>
                      {expandedSections.spiritual ? (
                        <ChevronDown className="h-5 w-5" />
                      ) : (
                        <ChevronRight className="h-5 w-5" />
                      )}
                    </div>
                    {expandedSections.spiritual && (
                      <p className="text-purple-700 text-sm">
                        This sacred place is believed to be even more
                        spiritually powerful than Kashi (Varanasi). Lord Vishnu
                        is believed to have compared Kashi and Karveer using
                        divine scales and declared Karveer more spiritually
                        significant.
                      </p>
                    )}
                  </div>

                  <div
                    className="bg-gradient-to-br from-orange-50 to-red-50 border border-orange-200 rounded-xl p-6 cursor-pointer hover:shadow-lg transition-all"
                    onClick={() => toggleSection("legend")}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-semibold text-orange-800">
                        Sacred Legend
                      </h3>
                      {expandedSections.legend ? (
                        <ChevronDown className="h-5 w-5" />
                      ) : (
                        <ChevronRight className="h-5 w-5" />
                      )}
                    </div>
                    {expandedSections.legend && (
                      <p className="text-orange-700 text-sm">
                        According to legends, this is the place where Sati's
                        eyes (or three eyes) fell when her body was dismembered
                        by Lord Vishnu's Sudarshan Chakra. The spiritual glory
                        of this region is documented in the Karveer Mahatmya, a
                        revered sacred text.
                      </p>
                    )}
                  </div>

                  <div
                    className="bg-gradient-to-br from-yellow-50 to-amber-50 border border-yellow-200 rounded-xl p-6 cursor-pointer hover:shadow-lg transition-all"
                    onClick={() => toggleSection("kirnotsav")}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-semibold text-yellow-800">
                        <Sunrise className="h-5 w-5 inline mr-2" />
                        Kirnotsav Festival
                      </h3>
                      {expandedSections.kirnotsav ? (
                        <ChevronDown className="h-5 w-5" />
                      ) : (
                        <ChevronRight className="h-5 w-5" />
                      )}
                    </div>
                    {expandedSections.kirnotsav && (
                      <p className="text-yellow-700 text-sm">
                        The temple is known for the unique Kirnotsav festival,
                        during which sun rays fall directly on the deity,
                        symbolizing divine energy. This astronomical phenomenon
                        occurs only twice a year and is considered highly
                        auspicious.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </Card>

            {/* Panchganga River */}
            <Card className="rounded-2xl shadow-xl border-orange-200">
              <div className="flex items-center mb-6">
                <Waves className="h-8 w-8 text-blue-500 mr-4" />
                <h2 className="text-3xl font-bold text-gray-800">
                  Panchganga River – Sacred Confluence
                </h2>
              </div>

              <div className="grid lg:grid-cols-2 gap-8">
                <div>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    The Panchganga River in Kolhapur is formed by the confluence
                    of five sacred rivers, making it a holy waterway that
                    enhances the spiritual significance of the Mahalaxmi Ambabai
                    Temple.
                  </p>

                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                    <h4 className="font-semibold text-blue-800 mb-4">
                      Sacred Benefits
                    </h4>
                    <ul className="space-y-2 text-blue-700">
                      <li className="flex items-start">
                        <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                        Bathing grants spiritual merit and liberation
                      </li>
                      <li className="flex items-start">
                        <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                        Flows past the Mahalaxmi Ambabai Temple
                      </li>
                      <li className="flex items-start">
                        <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                        Enhances the sacredness of the location
                      </li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h4 className="font-semibold text-gray-800 mb-4">
                    Five Confluent Rivers
                  </h4>
                  <div className="space-y-3">
                    {rivers.map((river, index) => (
                      <div
                        key={index}
                        className="flex items-center p-3 bg-white rounded-lg border border-gray-200 hover:shadow-md transition-all"
                      >
                        <div
                          className={`w-4 h-4 ${river.color} rounded-full mr-4`}
                        ></div>
                        <span className="font-medium text-gray-800">
                          {river.name}
                        </span>
                      </div>
                    ))}
                  </div>

                  <div className="mt-6 text-center">
                    <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-500 to-teal-500 text-white rounded-full">
                      <Waves className="h-4 w-4 mr-2" />
                      Panchganga = Five Rivers
                    </div>
                  </div>
                </div>
              </div>
            </Card>

            {/* Devotional Beliefs */}
            {/* <Card className="rounded-2xl shadow-xl border-orange-200">
              <div className="flex flex-col sm:flex-row sm:items-center mb-6 space-y-2 sm:space-y-0">
                <Heart className="h-6 w-6 sm:h-8 sm:w-8 text-red-500 sm:mr-4" />
                <h2 className="text-2xl sm:text-3xl font-bold text-gray-800">
                  Devotional Beliefs
                </h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
                <div className="bg-gradient-to-br from-red-50 to-pink-50 border border-red-200 rounded-xl p-4 md:p-6">
                  <h3 className="text-lg md:text-xl font-semibold text-red-800 mb-4">
                    Spiritual Benefits
                  </h3>
                  <ul className="space-y-3 text-red-700">
                    <li className="flex items-start text-sm md:text-base leading-relaxed">
                      <span className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span>
                        Visiting Karveer Kshetra grants{" "}
                        <strong>moksha (liberation)</strong>
                      </span>
                    </li>
                    <li className="flex items-start text-sm md:text-base leading-relaxed">
                      <span className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span>
                        Fulfills <strong>worldly desires</strong> and spiritual
                        aspirations
                      </span>
                    </li>
                    <li className="flex items-start text-sm md:text-base leading-relaxed">
                      <span className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span>
                        Blesses devotees with{" "}
                        <strong>prosperity and protection</strong>
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-xl p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-semibold text-green-800 mb-4">
                    Festival Celebrations
                  </h3>
                  <div className="space-y-3 sm:space-y-4">
                    <div className="flex items-center p-3 bg-white rounded-lg border border-green-200">
                      <Star className="h-4 w-4 sm:h-5 sm:w-5 text-green-500 mr-3 flex-shrink-0" />
                      <span className="font-medium text-green-800 text-sm sm:text-base">
                        Navratri
                      </span>
                    </div>
                    <div className="flex items-center p-3 bg-white rounded-lg border border-green-200">
                      <Sunrise className="h-4 w-4 sm:h-5 sm:w-5 text-green-500 mr-3 flex-shrink-0" />
                      <span className="font-medium text-green-800 text-sm sm:text-base">
                        Kirnotsav
                      </span>
                    </div>
                  </div>
                  <p className="text-green-700 text-xs sm:text-sm mt-4">
                    The temple draws <strong>millions of devotees</strong>{" "}
                    throughout the year, especially during these auspicious
                    festivals.
                  </p>
                </div>
              </div>
            </Card> */}

            {/* Call to Action */}
            <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-2xl p-8 text-center">
              <h3 className="text-2xl font-bold mb-4">
                🙏 Experience Divine Blessings
              </h3>
              <p className="text-lg mb-6 opacity-90">
                Visit the sacred Karveer Kshetra and receive the blessings of
                Shri Mahalaxmi Ambabai
              </p>
              <div className="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4">
                <button
                  onClick={() => navigate("/")}
                  className="bg-white text-orange-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all"
                >
                  🪔 Book a Puja
                </button>
                <button
                  onClick={() => navigate("/contact")}
                  className="bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-700 transition-all border-2 border-white"
                >
                  📞 Contact Temple
                </button>
              </div>
            </div>
          </div>
        </section>

        {selectedImage && (
          <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4">
            <div className="relative max-w-4xl max-h-full">
              {/* Close Button */}
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 z-50 bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-2 transition-all duration-200"
              >
                <X className="h-6 w-6" />
              </button>

              {/* Content Container */}
              <div className="bg-white rounded-lg overflow-hidden shadow-2xl max-w-full max-h-full">
                {/* Media Content */}
                <div className="relative">
                  {selectedImage.type === "video" ? (
                    // YouTube Video Embed
                    <div
                      className="relative w-full"
                      style={{ paddingBottom: "56.25%" }}
                    >
                      <iframe
                        src={`https://www.youtube.com/embed/${selectedImage.youtubeId}?autoplay=1&rel=0`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="absolute top-0 left-0 w-full h-full"
                        title={selectedImage.title}
                      />
                    </div>
                  ) : (
                    // Regular Image
                    <img
                      src={selectedImage.src}
                      alt={selectedImage.title}
                      className="w-full h-auto max-h-[70vh] object-contain"
                    />
                  )}
                </div>

                {/* Info Section */}
                <div className="p-6 bg-white">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        {selectedImage.title}
                      </h3>
                      <p className="text-gray-600 text-lg mb-4">
                        {selectedImage.description}
                      </p>

                      {/* Category Badge */}
                      <div className="flex items-center space-x-2">
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-orange-100 text-orange-800">
                          {selectedImage.type === "video" ? "🎥" : "📸"}
                          {selectedImage.category.charAt(0).toUpperCase() +
                            selectedImage.category.slice(1)}
                        </span>
                        {selectedImage.type === "video" && (
                          <a
                            href={`https://www.youtube.com/watch?v=${selectedImage.youtubeId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-red-100 text-red-800 hover:bg-red-200 transition-colors"
                          >
                            Watch on YouTube
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Navigation Arrows (Optional) */}
              <div className="absolute top-1/2 -translate-y-1/2 left-4">
                <button
                  onClick={() => {
                    const currentIndex = filteredImages.findIndex(
                      (img) => img.id === selectedImage.id
                    );
                    const prevIndex =
                      currentIndex > 0
                        ? currentIndex - 1
                        : filteredImages.length - 1;
                    setSelectedImage(filteredImages[prevIndex]);
                  }}
                  className="bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-3 transition-all duration-200"
                >
                  <ChevronLeft className="h-6 w-6" />
                </button>
              </div>

              <div className="absolute top-1/2 -translate-y-1/2 right-4">
                <button
                  onClick={() => {
                    const currentIndex = filteredImages.findIndex(
                      (img) => img.id === selectedImage.id
                    );
                    const nextIndex =
                      currentIndex < filteredImages.length - 1
                        ? currentIndex + 1
                        : 0;
                    setSelectedImage(filteredImages[nextIndex]);
                  }}
                  className="bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-3 transition-all duration-200"
                >
                  <ChevronRight className="h-6 w-6" />
                </button>
              </div>
            </div>

            {/* Click outside to close */}
            <div
              className="absolute inset-0 -z-10"
              onClick={() => setSelectedImage(null)}
            />
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default TempleHistory;
